module.exports = __webpack_public_path__ + "static/twitterimage-8c3852853442c44198fa95ba9e726ab7.png";